import { HEADER_HEIGHT } from '@/constants';
import { calendarFormatDateWithDay } from '@/helpers';
import { useDesktop } from '@/hooks';
import { Text } from '@mantine/core';
import { useEffect, useRef } from 'react';

export const EventDate = ({
  eventDate,
  isSelectedDay,
  scrolledIntoSelectDay,
  setScrolledIntoSelectDay,
  isFirstElement,
}: {
  eventDate: string;
  isSelectedDay?: boolean;
  scrolledIntoSelectDay?: boolean;
  setScrolledIntoSelectDay?: (value: boolean) => void;
  isFirstElement?: boolean;
}) => {
  const anchorRef = useRef<HTMLParagraphElement>(null);
  const isDesktop = useDesktop();

  useEffect(() => {
    if (isSelectedDay && !scrolledIntoSelectDay) {
      const timeoutId = setTimeout(() => {
        if (!anchorRef.current) return;

        if (isDesktop) {
          anchorRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (isFirstElement) {
            window.scrollTo({
              top: 0,
              behavior: 'smooth',
            });
          }
        } else {
          const elementPosition = anchorRef.current.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - HEADER_HEIGHT - 20;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
        setScrolledIntoSelectDay?.(true);
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [isSelectedDay, isDesktop, scrolledIntoSelectDay, setScrolledIntoSelectDay]);

  return (
    <Text
      ref={anchorRef}
      fw="bold"
      id={isSelectedDay ? 'event-date-select' : undefined}
      style={{ scrollMarginTop: `${HEADER_HEIGHT + 20}px` }}
    >
      {calendarFormatDateWithDay(eventDate)}
    </Text>
  );
};
